import React, { FC, memo } from 'react';

import logo from '@assets/logos/logo.png';

import HeaderButtons from '../HeaderButtons';
import useStyles from './styles.module';

interface Props {
  onClose: () => void;
}

const Header: FC<Props> = ({ onClose }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <div />
      {/* <img src={logo} alt="" className={classes.mobileLogo} /> */}
      <HeaderButtons onClose={onClose} />
    </div>
  );
};

export default memo(Header);
